class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("#predictive-search");
    this.closeButton = this.querySelector("[data-close]");
    this.mobileCloseNavButton = document.querySelector("[data-js-menu-button]");

    this.clickInterceptor = document.createElement("div");
    this.clickInterceptor.classList.add("click-interceptor");
    document.querySelector(".header__row-mobile .header__row-segment.left").appendChild(this.clickInterceptor);

    this.clickInterceptor.addEventListener("click", (e) => {
      this.close();
    });

    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.close();
    });

    this.input.addEventListener("click", (e) => {
      this.open();
    });

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  async getSearchResults(searchTerm) {
    try {
      const response = await fetch(
        `${this.dataset.route}?q=${searchTerm}&resources[options][fields]=title,product_type,tag,variants.title&section_id=predictive-search`
      );
      if (!response.ok) {
        throw new Error(response.status);
      }
      const text = await response.text();
      const resultsMarkup = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#shopify-section-predictive-search").innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
    } catch (e) {
      this.close();
    }
  }

  open() {
    this.predictiveSearchResults.style.display = "block";
    this.classList.add("active");
    this.clickInterceptor.style.pointerEvents = "all";
    this.input.placeholder = "";
  }

  close() {
    this.predictiveSearchResults.style.display = "none";
    this.classList.remove("active");
    this.clickInterceptor.style.pointerEvents = "none";
    this.input.placeholder = "Search...";
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);
